// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import PropTypes from 'prop-types';


export default function LogoutDialog(props) {

  const onCancelClick = props.onCancelClick
  const onLogoutClick = props.onLogoutClick

  const handleCancelClick = () => {
    onCancelClick && onCancelClick();
  }


  const handleLogoutClick = () => {
    onLogoutClick && onLogoutClick();
  }

  const openDialog = props.open || false

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={openDialog}
    >
      <DialogTitle>Confirmation</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure to logout?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button onClick={handleLogoutClick}>Logout</Button>
      </DialogActions>
    </Dialog>

  );
}

LogoutDialog.propTypes = {
  open: PropTypes.bool,
  onLogoutClick: PropTypes.func,
  onCancelClick: PropTypes.func,
};